import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

// import { CHANGE_PASSWORD_FORM } from '../forms/schema';

export default function useChangePassword() {
  const { state } = useProvider();
  const args = state;

  return useMutation<any, ApiError, any, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post({
        url: 'api/v1/auth/accounts/change-password',
        payload,
      });

      return data;
    },
    onSuccess: () => {
      toastSuccess('Successfully changed password.');
    },
  });
}
